<template>
  <div ref="container" class="d-flex justify-center align-center" style="background: black">
    <!--    @click="playOnClick"-->
    <video
      ref="player"
      @mouseover="onMouseOver"
      @mouseout="onMouseOut"
      @volumechange="$emit('volumechange', $event)"
      controls
      controlsList="nodownload"
      preload="none"
      :muted="mutedState"
      :autoplay="autoplay"
      :poster="posterUrl"
      :height="currentHeight"
      class="player"
      :style="style"
    >
      <source :src="src" :type="type" />
      Your browser does not support HTML5 video.
    </video>
  </div>
</template>

<script>
import common from '@/mixins/common';

export default {
  name: 'VideoPlayer',
  mixins: [common],
  props: {
    disablePlayBtn: { type: Boolean, default: false },
    autoplay: {
      type: Boolean,
      default: false,
    },
    objectFit: { type: String, default: 'cover' }, //cover or contain
    playOnMouseOver: { type: Boolean, default: true },
    controls: {
      type: Boolean,
      default: true,
    },
    height: Number,
    loop: {
      type: Boolean,
      default: false,
    },
    muted: {
      type: Boolean,
      default: false,
    },

    posterUrl: String,
    preload: {
      type: String,
      default: 'auto',
    },
    src: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'video/mp4',
    },
  },

  data() {
    return {
      mutedState: this.muted || this.autoplay,
      currentHeight: this.height ? this.height : null,
    };
  },
  watch: {
    muted(newVal) {
      this.mutedState = newVal;
      if (this.$refs.player) {
        this.$refs.player.muted = newVal;
      }
    },
    src() {
      this.$nextTick(() => {
        const player = this.$refs.player;
        if (!player) return;
        player.load();
        player.play().catch(() => {
          this.mutedState = true;
        });
      });
    },
  },

  computed: {
    style() {
      if (this.xs) {
        return `object-fit: cover;width:100%`;
      }
      console.debug('calculate style, this.currentHeight', this.currentHeight);
      if (this.currentHeight) {
        return `object-fit: ${this.objectFit};width:100%;max-height:${this.currentHeight}`;
      }

      return `object-fit:  ${this.objectFit};width:100%`;
    },
  },
  methods: {
    playOnClick() {
      console.debug('playOnClick');
      this.mutedState = false;
      if (this.$refs.player) {
        this.$refs.player
          .play()
          .then(() => {})
          .catch((err) => {
            // Occurs when the user has not interacted with the page and chrome avoids autoplay. However autoplay works using muted=true. So set to muted if not yet.
            // See https://developer.chrome.com/blog/autoplay/
            this.mutedState = true;
            this.$nextTick(() => {
              this.$refs.player.play();
            });
          });
      }
    },

    onVideoPlay() {
      if (this.disablePlayBtn) return;

      let el = this.$refs.player;
      let container = this.$refs.container;

      if (!this.height && el && container) {
        let videoWidth = el.videoWidth;
        let videoHeight = el.videoHeight;
        console.debug('videoWidth', videoWidth, 'videoHeight', videoHeight);
        let offsetWidth = container.offsetWidth;
        let offsetHeight = container.offsetHeight;
        console.debug('offsetWidth', offsetWidth, 'offsetHeight', offsetHeight);
        let currentHeight = videoHeight / (videoWidth / offsetWidth);
        if (currentHeight > offsetHeight) {
          this.currentHeight = offsetHeight;
        } else this.currentHeight = currentHeight;
        console.debug('calculated height', this.currentHeight);
      }
    },
    onMouseOver() {
      console.debug('onMouseOver');
      if (this.playOnMouseOver) {
        this.mutedState = true;
      }
    },
    onMouseOut() {
      console.debug('onMouseOut');
      if (this.playOnMouseOver) {
        this.startPlaying = true;
      }
    },
  },
};
</script>
<style scoped>
.player {
  background: black;
  border: 0;
  max-height: 60vh;
  overflow: hidden;
}
</style>
